import { lodging } from 'controllers/lodging';
import { groundTransportation } from 'src/common/controllers/ground-transportation';
import { car } from './car';
import { cruise } from './cruise';
// the order of this array matters, especially since the bernie v4 upgrade/react-router-v6 change.
// bernie effectively iterates through these in order to find a path match for the incoming page request.
export const controllers = [...groundTransportation, ...cruise, ...car, ...lodging];